import {ContentChild, Directive, TemplateRef} from '@angular/core';
import {IziviaSlideTemplateDirective} from './iziviaSlideTemplate.directive';

/**
 * Use this directive with {@link IziviaSlidesComponent}.
 *
 * Due to how Swiper.js integrate with Angular, usage must look like the following:
 * ```
 * <izivia-slides>
 *     <izivia-slide>
 *         <ng-template iziviaSlideTemplate>
 *             <!-- Slide 1 -->
 *         </ng-template>
 *     </izivia-slide>
 *
 *     <izivia-slide>
 *         <ng-template iziviaSlideTemplate>
 *             <!-- Slide 2 -->
 *         </ng-template>
 *     </izivia-slide>
 * </izivia-slides>
 * ```
 *
 * or by using `*ngFor`:
 *
 * ```
 * <izivia-slides>
 *     <izivia-slide *ngFor="let media of medias">
 *         <ng-template iziviaSlideTemplate>
 *             <!-- Slide content: {{media}} -->
 *         </ng-template>
 *     </izivia-slide>
 * </izivia-slides>
 * ```
 *
 * @see IziviaSlidesComponent
 * @see IziviaSlideTemplateDirective
 */
@Directive({
    // We want to use this as a classic DOM element instead of an attribute
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'izivia-slide'
})
export class IziviaSlideDirective {
    @ContentChild(IziviaSlideTemplateDirective, {read: TemplateRef}) template!: TemplateRef<HTMLElement>;
}
